import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import type { DailyRow } from '../../lib/api'

interface Props { days: DailyRow[] | null; loading?: boolean }

export function DailyTrend({ days, loading }: Props) {
  if (loading || !days) return <div className="empty-state">Indlæser…</div>
  if (days.length === 0) return <div className="empty-state">Ingen data i perioden.</div>

  const data = days.map(d => ({
    label: d.day.slice(5).replace('-', '-'),  // MM-DD
    Sessions: d.sessions,
    Leads: d.leads,
  }))

  return (
    <div className="chart-wrap">
      <div className="chart-legend">
        <span className="legend-dot" style={{ background: '#5fd9aa' }} /> Sessions
        <span className="legend-dot" style={{ background: '#3a8b6e', marginLeft: 16 }} /> Leads
      </div>
      <div style={{ width: '100%', height: 200 }}>
        <ResponsiveContainer>
          <BarChart data={data} margin={{ top: 6, right: 8, left: -16, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1a2620" vertical={false} />
            <XAxis dataKey="label" stroke="#6b7d75" tick={{ fontSize: 11 }} />
            <YAxis stroke="#6b7d75" tick={{ fontSize: 11 }} allowDecimals={false} />
            <Tooltip
              contentStyle={{ background: '#0f1a16', border: '1px solid #1a2620', color: '#e6f0eb', fontSize: 12 }}
              cursor={{ fill: 'rgba(95,217,170,0.05)' }}
            />
            <Bar dataKey="Sessions" fill="#5fd9aa" radius={[3, 3, 0, 0]} />
            <Bar dataKey="Leads" fill="#3a8b6e" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
